import firebase from "../../Config/firebase";
import React, {Component, Fragment} from "react";
import Article from "./Article/Article"
import {
    MDBListGroup,
    MDBTable,
    MDBTableBody,
    MDBTableHead,
    MDBBtn,
    MDBContainer,
    MDBModal,
    MDBModalBody,
    MDBModalHeader,
    MDBModalFooter,
    MDBCol, MDBRow
} from "mdbreact";
import {Link} from "react-router-dom";
import {faArrowLeft, faCheckCircle, faCheckSquare, faTimesCircle} from "@fortawesome/free-solid-svg-icons";
import classes from "./ArticleList.module.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import common from "../../Utils/common.module.css";

const db = firebase.firestore()

class ArticleList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            articles: [],
            isBannerLoaded: false,
            banner: [],
            model: false,
            isOpen: false,
            aidToBeDelete: ''
        }
    }


    componentDidMount() {
        this.getMyArticle()
        this.getArtBanner()
    }

    // componentWillReceiveProps(nextProps, nextContext) {
    //     if(this.props !== nextProps){
    //         this.setState({
    //             nextProps:this.props
    //         })
    //     }
    // }

    getArtBanner = () => {
        db.collection("Promote")
            .doc("Banner")
            .get()
            .then(doc => {
                    if (doc.exists) {
                        let allBanner = []
                        if (doc.data().hasOwnProperty("homeBanner")) {
                            doc.data().homeBanner.map(e => {
                                allBanner.push(e)
                            })
                            this.setState({
                                banner: allBanner
                            }, () => {
                                this.setState({
                                    isBannerLoaded: true
                                })
                            })
                        } else {
                            this.setState({
                                banner: []
                            }, () => {
                                this.setState({
                                    isBannerLoaded: true
                                })
                            })
                        }
                    } else {
                        this.setState({
                            banner: []
                        }, () => {
                            this.setState({
                                isBannerLoaded: true
                            })
                        })
                    }
                }
            )
            .catch(err => console.log(err))
    }

    getMyArticle = () => {
        db.collection('Article')
            .limit(8)
            // .where('isPublish','==',true)
            .orderBy('createDate', 'desc')
            .get()
            .then(docs => {
                if (!docs.empty) {
                    let allArticle = []
                    docs.forEach(function (doc) {
                        const article = {
                            id: doc.id,
                            ...doc.data()
                        }
                        allArticle.push(article)
                    })
                    this.setState({
                        articles: allArticle
                    }, () => {
                        this.setState({
                            isLoaded: true
                        })

                    })
                }

            })
    }


    delArticle = (val) => {
        db.collection('Article')
            .doc(val)
            .delete()
    }

    delArticleFromTable = (val) => {
        db.collection('Article')
            .doc(val)
            .get()
            .then(doc => {
                let newArticles = this.state.articles.filter(data => data.id !== val)
                this.setState({
                    isLoaded: false
                }, () => {
                    this.setState({
                        articles: newArticles
                    }, () => {
                        this.setState({
                            isLoaded: true
                        })
                    })
                })
            })
    }

    toggle = () => {
        this.setState({
            modal: !this.state.modal
        });
    }


    render() {
        return (
            <MDBContainer>
                <MDBRow>
                    <MDBCol xl={12} lg={12} md={12} sm={12} xs={12}>
                        <h2 className={classes.SectionTitle}>文章管理</h2>

                        <MDBModal isOpen={this.state.modal} toggle={this.toggle}>
                            <MDBModalHeader toggle={this.toggle}>提醒</MDBModalHeader>
                            <MDBModalBody>
                                此文章會完全消失!!
                            </MDBModalBody>
                            <MDBModalFooter>
                                <MDBBtn onClick={(e) => {
                                    this.delArticle(this.state.aidToBeDelete);
                                    this.delArticleFromTable(this.state.aidToBeDelete);
                                    this.toggle()
                                }} className={classes.ButtonItem}>Confirm</MDBBtn>
                                <MDBBtn color="secondary" onClick={this.toggle}>Close</MDBBtn>
                            </MDBModalFooter>
                        </MDBModal>
                        <MDBTable>
                            <MDBTableHead>
                                <tr>
                                    <th>#</th>
                                    <th>標題</th>
                                    <th>狀態</th>
                                    <th>功能</th>
                                </tr>
                            </MDBTableHead>
                            <MDBTableBody>
                                {
                                    this.state.isLoaded ?
                                        this.state.articles.map((article, index) => {
                                            return (
                                                <tr>
                                                    <td>{index + 1}</td>
                                                    <td>{article.title}</td>
                                                    <td>{article.isPublish ?
                                                        <FontAwesomeIcon icon={faCheckCircle} className={classes.Icon}/>
                                                        :
                                                        <FontAwesomeIcon icon={faTimesCircle} className={classes.Icon}/>
                                                    }</td>
                                                    <td>
                                                        <Link to={{
                                                            pathname: '/admin/articleList/editArticle/' + article.id,
                                                            state: {article: article}
                                                        }}>
                                                            <MDBBtn className={classes.ButtonItem}>Edit</MDBBtn>
                                                        </Link>
                                                        <Link to={{
                                                            pathname: '/article/' + article.id,
                                                            state: {article: article}
                                                        }}>
                                                            <MDBBtn className={classes.ButtonItem}>View</MDBBtn>
                                                        </Link>
                                                        <MDBBtn onClick={(event) => {
                                                            this.setState({
                                                                aidToBeDelete: article.id
                                                            })
                                                            this.toggle()
                                                        }}>Delete</MDBBtn>
                                                    </td>
                                                </tr>
                                            )
                                        }) : 'Loading'
                                }
                            </MDBTableBody>
                        </MDBTable>
                    </MDBCol>
                </MDBRow>
            </MDBContainer>

        );

    }
}

export default ArticleList;